module.exports = __webpack_public_path__ + "static/media/co2.2401ef58.svg";